export const VERSION = "0.16.2-SNAPSHOT";
